/*jshint esversion: 6 */

// Elements
const header = document.querySelector('header');
const responsiveMenu = document.getElementById('nav-mobile-trigger');
let headerIsActive = false;

// Overlay
const bodyOverlay = document.createElement('div');
bodyOverlay.id = 'body-overlay';
bodyOverlay.classList.add('d-none');
document.body.appendChild(bodyOverlay);

// Parameters
const activeThreshold = 120;
const buffer = 80;

// Functions
function updateHeaderFromScroll() {
	if (!header) return;
	if (!headerIsActive && window.scrollY > activeThreshold + buffer) {
		header.classList.add('active');
		headerIsActive = true;
	} else if (headerIsActive && window.scrollY < activeThreshold - buffer) {
		header.classList.remove('active');
		headerIsActive = false;
	}
}

function closeAllSubmenus(scope) {
	const root = scope || document;
	const items = root.querySelectorAll('.nav-expand.active');
	for (let i = 0; i < items.length; i++) {
		items[i].classList.remove('active');
		const parentList = items[i].closest('ul') || items[i].parentElement;
		if (parentList) parentList.classList.remove('submenu-active');
	}
}

function toggleMenuOpenClose(isOpening) {
	if (isOpening) {
		if (header) header.classList.remove('active');
		headerIsActive = false;
		document.body.style.overflow = 'hidden';
	} else {
		document.body.style.overflow = '';
		updateHeaderFromScroll();
	}
}

// Nav Link Control
document.addEventListener('click', function (e) {
	const expandLink = e.target.closest('.nav-expand-link');
	const backLink = e.target.closest('.nav-back-link');

	if (!expandLink && !backLink) return;

	const item = (expandLink || backLink).closest('.nav-expand');
	if (!item) return;

	const navRoot = item.closest('nav, .nav, .nav-wrapper, .menu, ul') || document;
	if (expandLink) {
		e.preventDefault();

		const openItems = navRoot.querySelectorAll('.nav-expand.active');
		for (let i = 0; i < openItems.length; i++) {
			const iItem = openItems[i];
			if (iItem !== item) {
				iItem.classList.remove('active');
				const parentList = iItem.closest('ul') || iItem.parentElement;
				if (parentList) parentList.classList.remove('submenu-active');
			}
		}

		item.classList.toggle('active');
		const parentList = item.closest('ul') || item.parentElement;
		if (parentList) parentList.classList.toggle('submenu-active');
	}

	if (backLink) {
		e.preventDefault();
		item.classList.remove('active');
		const parentList = item.closest('ul') || item.parentElement;
		if (parentList) parentList.classList.remove('submenu-active');
	}
});

// Close Mobile Menu on Navigation
document.addEventListener('click', function (e) {
	const link = e.target.closest('nav a[href]');

	if (!link) return;

	if (
		link.classList.contains('nav-expand-link') ||
		link.classList.contains('nav-back-link')
	) {
		return;
	}

	if (!document.body.classList.contains('nav-is-toggled')) return;

	document.body.classList.remove('nav-is-toggled');
	bodyOverlay.classList.add('d-none');

	// Restore scrolling
	document.body.style.overflow = '';

	closeAllSubmenus(document);
	updateHeaderFromScroll();
});

// Menu Toggle
if (responsiveMenu) {
	responsiveMenu.addEventListener('click', function () {
		const isOpening = !document.body.classList.contains('nav-is-toggled');

		document.body.classList.toggle('nav-is-toggled');
		bodyOverlay.classList.toggle('d-none');

		toggleMenuOpenClose(isOpening);
	});
}

// Overlay Click Close
bodyOverlay.addEventListener('click', function () {
	document.body.classList.remove('nav-is-toggled');
	bodyOverlay.classList.add('d-none');

	closeAllSubmenus(document);
	updateHeaderFromScroll();
});

// Scroll Header Handling
window.addEventListener('scroll', function () {
	if (!document.body.classList.contains('nav-is-toggled')) {
		updateHeaderFromScroll();
	}
});

// Initialize Header State
updateHeaderFromScroll();